import { render, staticRenderFns } from "./PreOrderUnitDetail.vue?vue&type=template&id=95504816"
import script from "./PreOrderUnitDetail.vue?vue&type=script&lang=js"
export * from "./PreOrderUnitDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports